require("firebase/firestore");
import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyADbbAwIRrRMvAkkRmb3qszuT0WF8jWTf4",
  authDomain: "bnc-admissions.firebaseapp.com",
  databaseURL: "https://bnc-admissions.firebaseio.com",
  projectId: "bnc-admissions",
  storageBucket: "bnc-admissions.appspot.com",
  messagingSenderId: "773210292347",
  appId: "1:773210292347:web:7e0bc4514e656961dfe2de",
  measurementId: "G-DWVTE377GT"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  var db = firebase.firestore();

  export const auth = firebase.auth()
  export const firestore = firebase.firestore
  export default db;
  
  
//********************************************************************* */
  //Add this to index.html for firebase analytics

  //firebase.analytics();
  //<!-- TODO: Add SDKs for Firebase products that you want to use
  //https://firebase.google.com/docs/web/setup#available-libraries -->
 // <script src="https://www.gstatic.com/firebasejs/7.14.1/firebase-analytics.js"></script>
//********************************************************************** */